export default __webpack_public_path__ + "static/media/logo-powered-by-autopass-outline.4aec7820.svg";